import React from 'react';
import Modal from '../../components/Modals/Modal';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import PrimaryButton from '../../components/Buttons/PrimaryButton';

function FiltersModal({
  showFilters,
  setShowFilters,
  headerGroups,
  setAllFilters
}) {

  return (
    <Modal title={'Set filters'} show={showFilters}>
      <div className='flex flex-col'>
        <div className='grid grid-cols-1 gap-y-1 my-8'>          
          {headerGroups.map((headerGroup) => headerGroup.headers.map((column) => (
            column.canFilter ? (
              <div>
                {column.render('Filter')}
              </div>
            ) : null
          )))}
        </div>
        <div className='grid grid-cols-2 gap-x-2'>
          <SecondaryButton onClick={() => {setAllFilters([]); setShowFilters(false)}} text='Reset'/>
          <PrimaryButton text='Save' onClick={() => setShowFilters(false)}/>
        </div>
      </div>
    </Modal>
  )
}

export default FiltersModal